module.exports = __webpack_public_path__ + "53c9d14262c42d49613a86ba668ee647.glb";